var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 57,
    viewBox: "0 0 73 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6736 13.6467L61.9248 35.9429C63.0234 37.9422 61.5769 40.3876 59.2956 40.3876H34.7932C32.5119 40.3876 31.0654 37.9422 32.1639 35.9429L44.4152 13.6467C45.5546 11.5729 48.5341 11.573 49.6736 13.6467Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1445 19.4975L43.888 25.8706C44.2171 26.4309 44.9848 26.5334 45.4494 26.079L52.008 19.6646C52.3897 19.2912 52.9975 19.2836 53.3884 19.6474L57.0095 23.0164C57.4339 23.4113 58.1043 23.3636 58.4686 22.9125L62.7263 17.6406",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9982 6.92762L54.4264 44.4332C55.5152 46.4323 54.0682 48.8682 51.7918 48.8682H10.9355C8.65909 48.8682 7.21207 46.4323 8.30091 44.4332L28.7291 6.92762C29.8657 4.8409 32.8616 4.8409 33.9982 6.92762Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0742 21.7112L25.4508 29.8529C25.8615 30.4748 26.7839 30.445 27.1536 29.7978L31.3017 22.5362C31.641 21.9423 32.463 21.8566 32.9175 22.3678L36.2891 26.1609C36.6776 26.598 37.3565 26.6099 37.7601 26.1867L42.0288 21.7112",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43.8271C66 49.1204 61.9251 53.3271 57 53.3271C52.0749 53.3271 48 49.1204 48 43.8271C48 38.5339 52.0749 34.3271 57 34.3271C61.9251 34.3271 66 38.5339 66 43.8271Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52 43.8271L56.6667 47.7646L62 39.8896",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.d853d51f497ad9f6d92bd37ad6fad357.svg";
export { ForwardRef as ReactComponent };